import VueSvgInlinePlugin from "vue-svg-inline-plugin"

export default (app) => {
  app.use(VueSvgInlinePlugin)
}